export function isPrint() {
  if (typeof window === 'undefined') return false
  return window.location?.hash === '#print'
}

export function getPdfPath(path: string) {
  // trim params and hash
  const [base] = path.split(/[?#]/)

  // trim slashes
  const slashless = base.replace(/^\/+|\/+$/g, '')

  // replace remaining slashes with dashes and add .pdf extension
  return `/pdf/${slashless.replaceAll('/', '-')}.pdf`
}

export function hideKetchBannerInPrintMode() {
  if (isPrint()) {
    const style = document.createElement('style')
    style.textContent = '#ketch-banner { display: none !important; visibility: hidden !important; opacity: 0 !important; }'
    document.head.appendChild(style)
  }
}
